import { render, staticRenderFns } from "./IconAdministration.vue?vue&type=template&id=607b57fc"
import script from "./IconAdministration.vue?vue&type=script&lang=ts"
export * from "./IconAdministration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports